export default __webpack_public_path__ + "static/media/jam.b43bcccd.png";